import { ReactNode } from 'react'
import cn from 'classnames'

import styles from './summary-wrap.module.scss';


type Props = {
  children: ReactNode
  className?: string
}

const SummaryWrap = ({ children, className }: Props) => {
  return (
    <div className={cn(styles.root, className)}>
      {children}
    </div>
  )
}

export default SummaryWrap
